/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function groupItems(_ref) {
  var items = _ref.items,
    maxTagsLength = _ref.maxTagsLength;
  var visibleItems = items;
  var remainingItems = null;
  if (items.length > maxTagsLength) {
    var cutFrom = maxTagsLength;
    remainingItems = items.slice(cutFrom);
    visibleItems = items.slice(0, cutFrom);
  }
  return {
    visibleItems: visibleItems,
    remainingItems: remainingItems
  };
}
var _default = groupItems;
exports.default = _default;